import React from 'react';
import { IconClock, IconClockRotateLeft } from '../../ui-kit/icons';
import PeriodSelector from '../../../utils/forms/PeriodSelector';
import { Button } from './../../ui-kit';
import { isLongerThan, AlertWith } from './utils';
import { debounce } from 'lodash';

// We extract the component to its own class so each
// row can have an isolated override times value.
const AttendanceTimes = ({ attendance, saveAttendance, currentReportStartTime, currentReportEndTime }) => {
  const startTime = attendance.start_time;
  const endTime = attendance.end_time;

  // time is being overridden if startTime or endTime is not null
  const isOverridingTimes = attendance.times_overridden;

  const saveThisAttendance = values => saveAttendance(attendance.id, values);

  const dateChangeDebounced = debounce(saveThisAttendance, 1000);

  // resetting the attendance's dates sets override times
  // to false, indicating that attendance's activity report
  // times must be displayed
  const resetDate = () => saveThisAttendance({ start_time: null, end_time: null, times_overridden: false });
  const startOverride = () =>
    saveThisAttendance({
      start_time: currentReportStartTime,
      end_time: currentReportEndTime,
      times_overridden: true
    });

  if (!isOverridingTimes) {
    return (
      <Button variant="secondary" size="sm" title={I18n.t('incident_responses.override_times')} onClick={startOverride}>
        <IconClock />
      </Button>
    );
  }

  return (
    <>
      <PeriodSelector startTime={startTime} endTime={endTime} onChange={dateChangeDebounced} horizontal={true} />
      <Button variant="secondary" size="sm" title={I18n.t('reset')} onClick={resetDate}>
        <IconClockRotateLeft />
      </Button>
      {isLongerThan(6, startTime, endTime) && <AlertWith warning={I18n.t('activity_reports.long_activity')} />}
    </>
  );
};

export default AttendanceTimes;
